module.exports = __webpack_public_path__ + "img/history.e3ebce95.svg";